/**
 * Created by stonewang on 2017/8/14.
 */
import React from 'react';
import {Row, Col, Button, Modal, Radio, Icon, Table, notification, Carousel, Card} from 'antd';
import DmsTab from '../../components/dmsTab';
import './home.css';
import '../../components/style.css';
import * as echarts from 'echarts';
import {hashHistory} from 'react-router';
import {getRemainTime, openNotice, config, CookieUtils} from '../../utils/index.js';
import {
    getMessageHome,
    getProductTop5,
    getOrderReport,
    setMessageRead,
    getNoMessageCount,
    fetchCustomModulesList,
    fetchLeftSideList,
    saveModules,
    fetchChannelList,
    credit,
    besic,
    getUnJoin,
    getConfirmMessage,
    changOrg,
    fetchAllChannelList, fetchAllBusinessLineList
} from '../../service/home';
import {getBillMessage} from '../../service/rebateBillManage';
import myObject from '../../utils/signals';

import {list} from '../../service/channelFunc';
import {message} from "antd/lib/index";
import setLanguageText from "../../utils/languageSet";

let imgData = {
    'photo': require('../../assets/images/ic-dy-man03.png')
};

class Home extends React.Component {
    constructor(props) {
        super(props);
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.ouId = window.sessionStorage.getItem('cur_ouId') || '';
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleOk2 = this.handleOk2.bind(this);
        this.handleCancel2 = this.handleCancel2.bind(this);
    }


    state = {
        button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end")),
        opts: ['订单金额', '订单数量'],
        btnLoad: false,
        render: 'none',
        optsIndex: 0,
        productOpts: ['商品销售TOP5'],
        messageOpts: ['通知'],
        creditData: [],
        styleOne: {},
        styleTwo: {},
        infoList: [],
        infoList1: [],
        orderSelect: {
            selectIndex: 1,
            data: [
                {
                    'val': 2,
                    'text': '按月'
                },
                {
                    'val': 3,
                    'text': '按季'
                },
                {
                    'val': 4,
                    'text': '按年'
                }
            ]
        },
        productTop: {
            selectIndex: 1,
            data: [
                {
                    'val': 2,
                    'text': '本月'
                },
                {
                    'val': 3,
                    'text': '本季'
                },
                {
                    'val': 4,
                    'text': '本年'
                }
            ]
        },
        productTop5s: [],
        messageData: [],
        haveMessage: 0,
        messageIndex: 0,
        // 所选择的分销渠道
        ouId: '82',
        ouName: '天正电气股份有限公司',
        channelName: '',
        channelCode: this.channelData == null ? "" : this.channelData.split('|')[1] || '',
        // 是否展示分销渠道Modal，为了不影响测试，先永久置为false
        visible: false,
        badge: 3,
        visible2: false,
        // 客戶未添加的列表
        ds1: [],
        ds2: [],
        sendDS2: [], // 保存时用到的，只存id
        selectedDS: [],
        disableRightAll: true,
        // 客戶保存的列表
        modulesList: [],
        channelList: [],
        businessLineList: [],
        creditParam: {
            customerId: 1050,
        },
        basicMeg: {
            areaName: '',
            regionName: '',
            message: {
                customerId: '',
                channelCode: this.channelData == null ? "" : this.channelData.split('|')[1] || '',
                remainAmount: '',
                taxAmount: '',
                nextAmount: '',
                descountAmount: '',
                holdLog: '',
                nextAmount2: ''
            }
        },
        languageSet: {}
    }

    toRight = (e) => {
        if (this.state.ds2.length < 6) {
            this.setState({
                ds1: this.state.ds1.filter((_, i) => _.id !== e.id),
                ds2: [...this.state.ds2, e],
                sendDS2: [...this.state.sendDS2, e.id]
            });
        }
    }

    toLeft = (e) => {
        // console.log(this.state.modulesList);
        this.setState({
            ds2: this.state.ds2.filter((_, i) => _.id !== e.id),
            ds1: [...this.state.ds1, e],
            sendDS2: this.state.sendDS2.filter((_, i) => _ !== e.id)
        }, () => {
            console.log(this.state.sendDS2);
        });
    }

    toRightAll = () => {
    }

    ouOnChange = (e) => {
        this.setState({
            ouId: e.target.value,
            ouName: e.target['data-name']
        });
    }
    onChange = (e) => {
        changOrg({
            orgId: this.state.ouId,
            channelCode: 'FX',
            businessLine: e.target['data-id']
        }).then(result => {
            if (result.status && result.status == true) {
                this.setState({
                    channelName: '全局',
                    channelCode: 'FX',
                    businessLineName: e.target.value,
                    businessLineCode: e.target['data-id'],
                    visible: false
                });
                var _data = e.target.value + '|' + e.target['data-id'];
                window.sessionStorage.setItem('cur_ouId', this.state.ouId);
                window.sessionStorage.setItem('cur_ouName', this.state.ouName);
                window.sessionStorage.setItem('cur_channelName', '全局');
                window.sessionStorage.setItem('cur_channel', '全局|FX');
                window.sessionStorage.setItem('cur_channelId', 'FX');
                window.sessionStorage.setItem('cur_businessName', e.target.value);
                window.sessionStorage.setItem('cur_business', _data);
                window.sessionStorage.setItem('cur_businessId', e.target['data-id']);
                myObject.channelSignal.dispatch(_data);
                this.getBasicMsg({channelCode: 'FX'});
                let that = this;
                Modal.info({
                    title: this.state.languageSet.tip2,
                    content: (<div
                        style={{fontSize: '16px'}}>{this.state.languageSet.tip3}<span
                        style={{color: '#d61518'}}>{this.state.languageSet.tip4}</span>{this.state.languageSet.tip5}
                    </div>),
                    onOk() {
                        getBillMessage().then(res => {
                            console.log(res)
                            if (res.code == 200 && res.data) {
                                Modal.info({
                                    title: '折扣结算单提示',
                                    content: (
                                        <div>{res.data}</div>
                                    ),
                                    onOk() {
                                        window.location.reload();
                                    },
                                });
                            } else {
                                window.location.reload();
                            }
                        });
                    }
                });
            } else {
                message.error(result.message);
            }
        });
    };

    refreshProductTop5(searchType) {
        let self = this;
        getProductTop5(searchType).then(result => {
            if (result && result.code == 200) {
                self.setState({
                    'productTop5s': result.data || []
                });
            } else {
                openNotice('error', '数据获取失败', (result && result.message) ? result.message : '');
            }
        });
    }


    getConfirmMessage() {
        getConfirmMessage().then(result => {
            if (result && result.code == 200) {
                result.data.forEach(item => {
                    let obj = <div dangerouslySetInnerHTML={{__html: item.content}} className='constrained-box'
                                   style={{width: '600px'}}/>;
                    Modal.info({
                        title: item.title,
                        content: obj,
                        width: '600px',
                        onOk() {
                            setMessageRead([item.id])
                        },
                    });
                });
            } else {
                openNotice('error', '数据获取失败', (result && result.message) ? result.message : '');
            }
        });
    }

    componentDidMount() {
        setLanguageText("home", this);
        this.generateData(1, 3);
        this.refreshProductTop5(3);
        this.refreshMsgFn();
        this.getMessageCountFn();
        this.getCustomModulesList();
        this.getChannelList(); // TODO 可优化
        this.getInfoList();
        this.interval = setInterval(() => this.tick(), 2000);
        var channelCodeId = window.sessionStorage.getItem('cur_channelId');
        if (channelCodeId) {
            this.getBasicMsg({channelCode: channelCodeId});
        }
        var loginData = JSON.parse(window.localStorage.getItem('ownIs'));
        if (loginData.ownEmp) {
            this.state.styleOne = {
                display: 'none',
            }
            this.state.styleTwo = {
                display: 'none',
            }
            this.setState({styleOne: this.state.styleOne, styleTwo: this.state.styleTwo})
        } else {
            this.creditChange();
        }
        if (!loginData.ownEmp && !loginData.isSecond) {
            this.state.styleOne = {
                display: 'block',
            };
            this.state.styleTwo = {
                display: 'block',
            };
            this.setState({styleOne: this.state.styleOne, styleTwo: this.state.styleTwo})
        }
        this.getUnJoinList();
    }

    getInfoList() {
        list({isPublish: "1", isShow: "", p: "1", s: "5", type: "5"}).then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    infoList: result.data
                })
            } else {
                message.error(result.message);
            }
        })
        list({isPublish: "1", isShow: "", p: "1", s: "9", types: ["1", "2", "3", "5", "6"]}).then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    infoList1: result.data
                })
            } else {
                message.error(result.message);
            }
        })
    }


    getChannelList = () => {
        fetchAllChannelList().then(result => {
            if (result && result.code == 200 && result.status == true) {
                if (result.data.length > 0 && window.sessionStorage.getItem('session_login_status') == 1) {
                    this.setState({visible: true});
                    window.sessionStorage.removeItem("session_login_status");
                } else {
                    this.getConfirmMessage();
                    this.setState({visible: false});
                }
                this.setState({
                    channelList: result.data
                });
                window.sessionStorage.setItem('channel_list', JSON.stringify(result.data));
                // 自定义事件 通知App.js
                // myObject.started.dispatch(result.data);
            } else {
                openNotice('error', '数据获取失败', (result && result.message) ? result.message : '');
            }
        });

        fetchAllBusinessLineList().then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    businessLineList: result.data
                });
                window.sessionStorage.setItem('businessLine_list', JSON.stringify(result.data));
            } else {
                message.error(result.message);
            }
        });
    }

    getCustomModulesList = () => {
        fetchCustomModulesList().then(result => {
            if (result && result.code == 200) {
                const data = result.data || [];
                const arr = [];
                data.forEach(item => {
                    arr.push(item.id);
                });
                this.setState({
                    modulesList: result.data,
                    sendDS2: arr
                });
            } else {
                const arr = [];
                this.state.modulesList.forEach(item => {
                    arr.push(item.id);
                });
                this.setState({
                    sendDS2: arr
                });
                openNotice('error', '数据获取失败', (result && result.message) ? result.message : '');
            }
        });
    }

    getBasicMsg = (param) => {
        besic(param).then(result => {
            if (result && result.code == 200) {
                if (result.data) {
                    this.setState({
                        basicMeg: result.data
                    });
                } else {
                    this.setState({
                        basicMeg: {
                            "areaName": "",
                            "regionName": "",
                            "message": {
                                "holdLog": "",
                                "receivable": "",
                                "taxAmount": "",
                                "customerId": "",
                                "channelCode": "",
                                "remainAmount": "",
                                "discountAmount": "",
                                "nextAmount": "",
                                "nextAmount2": "",
                                "receivable2": ""
                            }
                        }
                    });
                }

            } else {
                openNotice('error', '数据获取失败', (result && result.message) ? result.message : '');
            }
        });
    }

    getUnit(lists) {
        let num = 0;
        for (let list of lists) {
            for (let field in list) {
                if (num < list[field]) {
                    num = list[field];
                }
            }
        }
        let returnObj = {};
        if (num / 10000 > 1) {
            returnObj.unit = '单位/万元';
            returnObj.num = 10000;
        } else if (num / 1000000000 > 1) {
            returnObj.unit = '单位/亿元';
            returnObj.num = 1000000000;
        } else {
            returnObj.unit = '单位/元';
            returnObj.num = 1;
        }
        return returnObj;
    }

    generateData(key1, key2) {
        /* key1(金额\数量) key2(月,季,年) */
        let self = this;
        getOrderReport(key1, key2).then(result => {
            if (result && result.code == 200) {
                let xData = [];
                let yData = [];
                let resultData = result.data || [];
                let returnObj = self.getUnit(resultData);
                for (let data of resultData) {
                    for (let field in data) {
                        xData.push(field);
                        if (key1 == 1) {
                            if (returnObj.num > 1) {
                                yData.push((data[field] / returnObj.num).toFixed(2));
                            } else {
                                yData.push(data[field]);
                            }
                        } else {
                            yData.push(data[field]);
                        }
                    }
                }
                let params = {
                    'unit': key1 == 1 ? returnObj.unit : '单位/个',
                    'title': key1 == 1 ? '订单金额' : '订单数量',
                    'xData': xData,
                    'yData': yData
                };
                self.refreshCharts(params);
            } else {
                openNotice('error', '数据获取失败', (result && result.message) ? result.message : '');
            }
        });
    }

    refreshCharts(param) {
        let option = {
            title: {
                text: '',
                subtext: param.unit
            },
            grid: {
                y: 50
            },
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                data: [param.title]
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: param.xData
            },
            yAxis: {
                type: 'value',
                axisLabel: {
                    rotate: 0 //倾斜度
                }
            },
            series: [
                {
                    name: param.title,
                    type: 'line',
                    data: param.yData
                }
            ]
        };
        var mainChart = echarts.init(document.getElementById('orderChart'));
        mainChart.setOption(option, true);
    }

    tapTabFn(index) {
        this.setState({orderSelect: {...this.state.orderSelect, selectIndex: index}});
        this.generateData(this.state.optsIndex + 1, this.state.orderSelect.data[index].val);
    }

    tapProductTabFn(index) {
        this.setState({productTop: {...this.state.productTop, selectIndex: index}});
        this.refreshProductTop5(this.state.productTop.data[index].val);
    }

    changeHandle({item, key, keyPath}) {
        this.setState({optsIndex: key});
        this.generateData(key + 1, this.state.orderSelect.data[this.state.orderSelect.selectIndex].val);
    }

    toMsgDetail(item) {
        /* 消息详情 */
        let self = this;
        // console.log(item)
        setMessageRead([item.id]).then(() => {
            getNoMessageCount().then((result) => {
                if (result && result.code == 200) {
                    sessionStorage.setItem('not_message_count', result.data.message);
                    self.setState({
                        'haveMessage': result.data.message
                    });
                }
            });
        });
        if (item.messageType == 1) {
            hashHistory.push('/order/' + item.entityId + '/conventionalDetail/null');
        }
        if (item.messageType == 2) {
            hashHistory.push('/order/' + item.entityId + '/projectDetail/null');
        }
        if (item.messageType == 3) {
            hashHistory.push('/order/' + item.entityId + '/partnersDetail/null');
        }
        if (item.messageType == 4) {
            hashHistory.push('/traceOrder/' + item.entityId);
        }
        if (item.messageType == 5) {
            hashHistory.push('/invoiceManagement/' + item.entityId);
        }
        if (item.messageType == 6) {
            hashHistory.push('/returnGoods/' + item.entityId);
        }
        if (item.messageType == 7 || item.messageType == 8) {
            // 7,账号开通申请 8,增值税开通申请
            hashHistory.push('/message/' + item.entityId + '/' + item.messageType);
        }
        if (item.messageType == 9) {
            // 退货订单
            hashHistory.push('/returnOrder/' + item.entityId);
        }
    }

    toMoreMsg() {
        /* 查询更多消息 */
        hashHistory.push('/message');
    }

    toCredit() {
        hashHistory.push('/creditChange');
    }

    /**
     * 授信变动
     *
     */
    creditChange() {
        const self = this;
        let thirdId = window.localStorage.getItem("thirdId");
        var param = {
            customerId: thirdId,
            channelCode: this.channelData == null ? "" : this.channelData.split('|')[1] || '',
            p: 1,
            s: 10
        }
        credit(param).then(function (result) {
            console.dir(result)
            if (result && result.code == 200) {
                self.setState({
                    creditData: result.data.data,
                });
            } else {
                openNotice('error', '数据获取失败', '');
            }
        });

    }

    tick = () => {
        this.setState({render: 'block'});
        clearInterval(this.interval);
    }

    refreshMsgFn() {
        /* 消息刷新 */
        let self = this;
        self.setState({
            'btnLoad': true
        });
        getMessageHome().then(result => {
            self.setState({
                'btnLoad': false
            });
            if (result && result.code == 200) {
                self.setState({
                    'messageData': result.data || []
                });
            } else {
                openNotice('error', '消息数据获取失败', (result && result.message) ? result.message : '');
            }
        });
    }

    getMessageCountFn() {
        let count = sessionStorage.getItem('not_message_count');
        let self = this;
        if (!count) {
            setTimeout(() => {
                self.getMessageCountFn();
            }, 100);
        } else {
            self.setState({
                'haveMessage': count
            });
        }
    }

    handleOk = () => {
        this.setState({visible: false});
    }

    handleCancel = () => {
        this.setState({visible: false});
    }

    // 保存自定义模块
    handleOk2 = () => {
        this.setState({visible2: false});
        if (this.state.sendDS2.length == 0) {
            openNotice('error', '提示', '已选功能不能为空');
        }
        saveModules({Itemselector: this.state.sendDS2}).then(result => {
            if (result && result.code == 200) {
                openNotice('success', '保存成功');
                this.getCustomModulesList();
            } else {
                openNotice('error', '保存失败', (result && result.message) ? result.message : '');
            }

        });
    };

    handleCancel2 = () => {
        this.setState({visible2: false});
    }

    openModulesDialog = () => {
        // console.log(this.state.modulesList);
        // console.log(this.state.ds2);
        this.setState({ds2: this.state.modulesList});
        this.setState({visible2: true});
        this.getLeftSideModules();
    }

    getLeftSideModules = () => {
        fetchLeftSideList().then(result => {
            if (result && result.code == 200) {
                this.setState({
                    ds1: result.data
                });
            } else {
                openNotice('error', '消息数据获取失败', (result && result.message) ? result.message : '');
            }
        });
    }

    //获取未参与的问卷
    getUnJoinList = () => {
        getUnJoin().then(result => {
            if (result.data && result.code == 200) {
                notification.open({
                    message: '您有未参与的问卷调查',
                    description: <a href={`#/survey/${result.data.id}`}>{result.data.title}</a>,
                });
            }
        });
    }

    //头部快捷功能
    toHref(item) {
        // console.log(item);
        hashHistory.push(`/${item.code}`);
    }

    render() {
        const RadioGroup = Radio.Group;
        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
            marginLeft: '35px',
            fontSize: '17px'
        };
        const {
            creditData,
            opts,
            productOpts,
            messageOpts,
            optsIndex,
            orderSelect,
            productTop,
            productTop5s,
            messageData,
            btnLoad,
            visible,
            badge,
            visible2,
            ds1,
            ds2,
            modulesList,
            channelList,
            creditParam,
            businessLineList,
            styleOne,
            styleTwo,
            channelCode,
            basicMeg,
            infoList,
            render,
            infoList1
        } = this.state;
        let info = (infoList || []).map(function (ele) {
            return <div><img width={"100%"} src={`${config.server}${ele.filePath}`}></img>
                <div style={{backgroundColor: 'rgba(0,0,0,0.4)'}}><a
                    href={`#/channelFunc/${ele.id}`}
                    style={{
                        color: '#fff',
                        fontSize: '17px',
                    }}> {ele.title}</a></div>
            </div>
        });
        let info1 = (infoList1 || []).map(function (ele) {
            return <p className="aClass"><a href={`#/channelFunc/${ele.id}`}>▶ {ele.title}</a></p>
        });
        var self = this;
        var orderIndex = orderSelect.selectIndex;
        var orderStatusHtml = orderSelect.data.map(function (qst, key) {
            return <a key={key} onClick={self.tapTabFn.bind(self, key)}
                      className={orderIndex === key ? 'selected' : ''}>{qst.text}</a>
        });
        var productIndex = productTop.selectIndex;
        var productTopHtml = productTop.data.map(function (qst, key) {
            return <a key={key} onClick={self.tapProductTabFn.bind(self, key)}
                      className={productIndex === key ? 'selected' : ''}>{qst.text}</a>
        });
        var productTopLiHtml = productTop5s.map(function (qst, key) {
            return <li key={key}>
                <span className="top">{key + 1}</span>
                <img src={qst.productImg ? config.server + qst.productImg : ''} alt=""/>
                <div>
                    <div>
                        <p>{qst.productName}</p>
                        <p className="count">销量<span>{qst.sellNum}</span></p>
                    </div>
                </div>
            </li>
        });
        var messageLiHtml = messageData.map(function (qst, key) {
            return <li key={key} onClick={self.toMsgDetail.bind(self, qst)}>
                <img className="msg" src={qst.photoUrl ? (config.server + qst.photoUrl) : imgData['photo']}
                     alt=""/><span
                className="redDot" style={{display: qst.isRead ? 'none' : 'block'}}></span>
                <div className="msg">
                    <div>
                        <p style={{color: qst.isRead ? '#777' : '#000'}}
                           className="na">{qst.title}<span>{getRemainTime(qst.createdDate)}</span></p>
                        <p style={{color: qst.isRead ? '#777' : '#000'}}><span>{qst.subject}</span></p>
                    </div>
                </div>
            </li>
        });
        var renderMessageCountFn = function (key) {
            if (key > 0) {
                return <span className="message_count">{key}</span>
            } else {
                return '';
            }
        };
        const itemLayout = {
            padding: '8px 0',
            textAlign: 'center',
            cursor: 'pointer'
        };
        const iconLayout = {
            fontSize: '16px'
        };
        const settingLayout = {
            float: 'right',
            fontSize: '10px',
            margin: '3px 3px 0 0',
            cursor: 'pointer'
        };
        const columns1 = [{
            title: '未选功能',
            dataIndex: 'name',
            key: 'name',
            render: text => <span>{text}</span>
        }, {
            title: '操作',
            key: 'action',
            className: 'alignCenter',
            render: (text, record, index) => <Button onClick={this.toRight.bind(this, record)}>{'>'}</Button>
        }];
        const columns2 = [{
            title: '操作',
            key: 'action',
            className: 'alignCenter',
            render: (text, record, index) => <Button onClick={this.toLeft.bind(this, record)}>{'<'}</Button>
        }, {
            title: '已选功能',
            dataIndex: 'name',
            key: 'name',
            render: text => <span>{text}</span>
        }];
        const creditColumns = [{
            /**
             *             {
                "RN": 1,
                "pay": "滚动3个月",
                "channelName": "电力",
                "projectName": "天正集团有限公司长春销售公司",
                "sxeAmount": 1000000,
                "discountAmount": 0,
                "yyAmount": 217412.9,
                "kyAmount": 782587.1
            },
             */
            title: '授信方式',
            dataIndex: 'pay',
            key: 'pay'
        }, {
            title: '渠道',
            dataIndex: 'channelName',
            key: 'channelName'
        }, {
            title: '授信项目或购货单位',
            dataIndex: 'projectName',
            key: 'projectName'
        }, {
            title: '授信额度',
            dataIndex: 'sxeAmount',
            key: 'sxeAmount'
        }, {
            title: '折扣池余额',
            dataIndex: 'discountAmount',
            key: 'discountAmount'
        }, {
            title: '已用额度',
            dataIndex: 'yyAmount',
            key: 'yyAmount'
        }, {
            title: '可用额度',
            dataIndex: 'kyAmount',
            key: 'kyAmount'
        }];
        const rowSelection1 = {
            onChange: (selectedRowKeys, selectedRows) => {
                // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                if (selectedRows.length > 0) {
                    self.setState({disableRightAll: false});
                } else {
                    self.setState({disableRightAll: true});
                }
                self.setState({selectedDS: selectedRows});
            },
            onSelect: (record, checked, selectedRows) => {
            }
        };
        const rowSelection2 = {
            onChange: (selectedRowKeys, selectedRows) => {
                console.log(`选中key: ${selectedRowKeys}`, '选中数组: ', selectedRows);
            }
        };

        const customMapper = (item, index) => {
            return (
                <Col key={index} span={3} style={itemLayout} onClick={this.toHref.bind(this, item)}>
                    <i className={item.icon} style={iconLayout}></i>
                    <span style={{display: 'block'}}>{item.name}</span>
                </Col>
            )
        };

        const channelMapper = (item, index) => {
            if (item.orgIds.indexOf(this.state.ouId) >= 0) {
                return <Radio key={'radio_' + index} data-id={item.code} style={radioStyle}
                              value={item.name}>{item.name}</Radio>;
            }
        };
        return <div className="home-body">
            <Row style={{backgroundColor: '#fff'}}>
                {
                    modulesList.map(customMapper)
                }
                <i className="anticon anticon-setting" style={settingLayout} onClick={this.openModulesDialog}></i>
            </Row>
            <Row gutter={16}>
                <Col span={12} style={{paddingRight: "0px"}}>
                    <div>
                        <DmsTab options={['公告栏']} defaultKey={0}>
                        </DmsTab>
                        <Col span={12}>
                            <div style={{
                                display: render
                            }}>
                                <Carousel autoplay>
                                    {info}
                                </Carousel>
                            </div>
                        </Col>
                        <Col span={12}>
                            <div className="home-content">
                                <Card style={{lineHeight: "30px"}} noHovering={true} bordered={false}>
                                    {info1}
                                    <p><a href={`#/infoRead`}> 查看更多消息</a></p>
                                </Card>
                            </div>
                        </Col>

                    </div>
                </Col>
                <Col span={12} style={{paddingLeft: "0px"}}>
                    <div className="home-content">
                        {renderMessageCountFn(this.state.haveMessage)}
                        <DmsTab options={messageOpts} defaultKey={0}>
                            <Button className="refresh_msg" icon="reload" loading={btnLoad}
                                    onClick={this.refreshMsgFn.bind(this)}/>
                        </DmsTab>
                        <div className="product_top_5">
                            <ul>
                                {messageLiHtml}
                                <li style={{display: messageData.length == 0 ? 'none' : 'block'}}>
                                    <div className="msg">
                                        <div className="href" onClick={self.toMoreMsg}>
                                            查看更多消息
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row gutter={16} style={styleTwo}>
                <Col span={24}>
                    <div className="home-content">
                        <DmsTab options={['基本信息']} defaultKey={0}>
                        </DmsTab>
                        <div style={{padding: 20}}>
                            <Row>
                                <Col span={2}>所属片区：{basicMeg.areaName}</Col>
                                <Col span={2}>所属省份：{basicMeg.regionName}</Col>
                                <Col
                                    span={7}>总欠款金额：股份：{basicMeg.message ? basicMeg.message.receivable2 : ''}；天毅行：{basicMeg.message ? basicMeg.message.receivable : ''}</Col>
                                <Col span={4}>今年已开票金额：{basicMeg.message ? basicMeg.message.taxAmount : ''}</Col>
                                <Col span={4}>剩余开票金额：{basicMeg.message ? basicMeg.message.remainAmount : ''}</Col>
                                <Col span={4}>折扣池余额：{basicMeg.message ? basicMeg.message.discountAmount : ''}</Col>
                            </Row>
                            <Row>
                                <Col
                                    span={23}>股份滚动授信本月到期金额：{basicMeg.message ? basicMeg.message.nextAmount2 : ''}</Col>
                            </Row>
                            <Row>
                                <Col
                                    span={23}>天毅行滚动授信本月到期金额：{basicMeg.message ? basicMeg.message.nextAmount : ''}</Col>
                            </Row>
                            <Row>
                                <Col
                                    span={23}>最近单位暂挂金额：{basicMeg.message ? basicMeg.message.holdLog : ''}</Col>
                            </Row>
                            <Row>
                                <Col span={23}><font
                                    style={{color: 'red'}}>备注说明：年度12月份应还金额按照销售产品协议中的条款执行</font></Col>
                            </Row>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row gutter={16} style={styleTwo}>
                <Col span={24}>
                    <div className="home-content">
                        <DmsTab options={['销方信息']} defaultKey={0}>
                        </DmsTab>
                        <div style={{padding: 20}}>
                            <Row>
                                <Col
                                    span={6}>{this.ouId == 82 ? '名称：浙江天正电气股份有限公司' : '名称：上海天毅行智能电气有限公司'}</Col>
                                <Col
                                    span={6}>{this.ouId == 82 ? '税号：91330000717612987P' : '税号：91310115MA7B4E4Y3N'}</Col>
                                <Col
                                    span={6}>{this.ouId == 82 ? '地址：乐清市柳市苏吕工业区' : '地址：上海自由贸易试验区康桥东路388号8幢220室'}</Col>
                                <Col
                                    span={6}>{this.ouId == 82 ? '开户行：农行乐清经济开发区支行' : '开户行：招商银行股份有限公司上海周浦支行'}</Col>
                            </Row>
                            <Row>
                                <Col span={6}>{this.ouId == 82 ? '行号：103333327062' : '行号：308290003853'}</Col>
                                <Col
                                    span={6}>{this.ouId == 82 ? '账号：19270601040002121' : '账号：121942920310902'}</Col>
                                <Col span={6}>{this.ouId == 82 ? '电话：0577-62776776' : '电话：021-31198730'}</Col>
                            </Row>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row gutter={16} style={styleOne}>
                <Col span={24}>
                    <div className="home-content">
                        <DmsTab options={['授信信息']} defaultKey={0}>
                        </DmsTab>
                        <Table
                            rowKey={record => record.RN}
                            columns={creditColumns}
                            pagination={false}
                            dataSource={creditData}
                            bordered
                            style={{padding: 20}}
                        />
                        <div onClick={this.toCredit}
                             style={{paddingLeft: 20, paddingBottom: 10, color: '#2eabff', cursor: 'pointer'}}>
                            查看更多
                        </div>
                    </div>
                </Col>
            </Row>
            <Row gutter={16} style={{display: 'none'}}>
                <Col span={12} lg={12} md={24} sm={24} xs={24}>
                    <div className="home-content" style={{height: '450px'}}>
                        <DmsTab options={opts} defaultKey={parseInt(optsIndex, 10)}
                                onChange={self.changeHandle.bind(self)}>
                        </DmsTab>
                        <div className="tab_li">
                            <div>
                                {orderStatusHtml}
                            </div>
                        </div>
                        <div className="order_chart" id="orderChart"></div>
                    </div>
                </Col>
                <Col span={12} lg={12} md={24} sm={24} xs={24}>
                    <div className="home-content" style={{height: '450px'}}>
                        <DmsTab options={productOpts} defaultKey={0}>
                        </DmsTab>
                        <div className="tab_li">
                            <div>
                                {productTopHtml}
                            </div>
                        </div>
                        <div className="product_top_5">
                            <ul>
                                {productTopLiHtml}
                            </ul>
                        </div>
                    </div>
                </Col>
            </Row>

            <Modal
                visible={visible}
                title={this.state.languageSet.businessLine}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                footer={null}
                closable={false}
                maskClosable={false}
                width={400}
            >
                <div style={{marginBottom: '20px'}}>
                    <RadioGroup onChange={this.ouOnChange} defaultValue={this.state.ouId}>
                        <Radio key='ouradio_1' data-name={this.state.languageSet.gfcompany} style={radioStyle}
                               value={'82'}
                        >{this.state.languageSet.gfcompany}</Radio>
                        <Radio key='ouradio_2' data-name={this.state.languageSet.tyxcompany} style={radioStyle}
                               value={'86'}
                        >{this.state.languageSet.tyxcompany}</Radio>
                    </RadioGroup>
                </div>
                <hr style={{height: 1}}/>
                <div style={{marginBottom: '20px', marginTop: '20px'}}>
                    <RadioGroup onChange={this.onChange} value={this.state.channelName}>
                        {
                            businessLineList.map(channelMapper)
                        }
                    </RadioGroup>
                </div>
                <hr style={{height: 1}}/>
                <div>{this.state.languageSet.tip}</div>
            </Modal>

            <Modal
                visible={visible2}
                title={this.state.languageSet.tip1}
                onOk={this.handleOk2}
                onCancel={this.handleCancel2}
                maskClosable={false}
            >
                <div>
                    <Row gutter={16}>
                        <Col span={10}>
                            <Table
                                /*rowSelection={rowSelection1}
                                 selectWay="onSelect"*/
                                columns={columns1}
                                dataSource={ds1}
                                pagination={false}
                                rowKey="id"
                                bordered
                            />
                        </Col>
                        <Col span={4} style={{position: 'absolute', top: '50%', left: '42%'}}>
                            <Row type="flex" justify="center">
                                <Col>
                                    <Button onClick={this.toRightAll}
                                            disabled={this.state.disableRightAll}>{'>>'}</Button>
                                </Col>
                                <Col style={{marginTop: 10}}>
                                    <Button disabled={true}>{'<<'}</Button>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={10} style={{float: 'right'}}>
                            <Table
                                /*rowSelection={rowSelection2}*/
                                columns={columns2}
                                dataSource={ds2}
                                pagination={false}
                                rowKey="id"
                                bordered
                            />
                        </Col>
                    </Row>
                </div>
            </Modal>
        </div>
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/routes/home/index.js